import { BaseModal } from './BaseModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXTwitter, faFacebook, faWhatsapp, faInstagram  } from '@fortawesome/free-brands-svg-icons'
import { GameStats } from '../../lib/localStorage'
import { MAX_CHALLENGES } from '../../constants/settings'
import { GAME_TITLE } from '../../constants/strings'
import { generateEmojiGrid } from '../../lib/share'
import { getEmojiTiles } from '../../lib/share'

type Props = {
  isOpen: boolean
  handleClose: () => void
  solution: string
  guesses: string[]
  gameStats: GameStats
  isLatestGame: boolean
  isGameLost: boolean
  isHardMode: boolean,
  isDarkMode: boolean,
  isHighContrastMode: boolean,
  isGameWon: boolean
}

export const ShareModal = ({
  isOpen,
  handleClose,
  solution,
  guesses,
  gameStats,
  isLatestGame,
  isGameLost,
  isHardMode,
  isDarkMode,
  isHighContrastMode,
  isGameWon
}: Props) => {

  const emojiGrid = `${GAME_TITLE+" "}${isGameLost ? 'X' : guesses.length}/${MAX_CHALLENGES}${isHardMode ? '*' : ''}\n\n${generateEmojiGrid(
      solution,
      guesses,
      getEmojiTiles(isDarkMode, isHighContrastMode)
    )}\n\nhttps://cosylab.iiitd.edu.in/foodle/`;

  const shareStatusOnTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(emojiGrid)}`
    window.open(twitterUrl, '_blank')
  }

  const shareStatusOnFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(emojiGrid)}`
    window.open(facebookUrl, '_blank')
  }

  const shareStatusOnWhatsApp = () => {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(emojiGrid)}`
    window.open(whatsappUrl, '_blank')
  }
  const shareOnInstagram = () => {
    //     // Construct the Instagram URL with the pre-filled caption and image
        const instagramUrl = `https://www.instagram.com/?url=${encodeURIComponent(emojiGrid)}`

        window.open(instagramUrl, '_blank')
      }

  return (
        <BaseModal title="Share Game" isOpen={isOpen} handleClose={handleClose}>
          <div className="pt-4 flex justify-around">
            <div className="flex flex-col items-center">
              <FontAwesomeIcon
                icon={faXTwitter}
                className="h-8 w-8 cursor-pointer text-blue-500"
                onClick={shareStatusOnTwitter}
              />
              <span className="text-sm mt-1 text-white m-2">Twitter</span>
            </div>
            <div className="flex flex-col items-center">
              <FontAwesomeIcon
                icon={faFacebook}
                className="h-8 w-8 cursor-pointer text-blue-700"
                onClick={shareStatusOnFacebook}
              />
              <span className="text-sm mt-1 text-white m-2">Facebook</span>
            </div>
            <div className="flex flex-col items-center">
              <FontAwesomeIcon
                icon={faWhatsapp}
                className="h-8 w-8 cursor-pointer text-green-500"
                onClick={shareStatusOnWhatsApp}
              />
              <span className="text-sm mt-1 text-white m-2">WhatsApp</span>
            </div>
            <div className="flex flex-col items-center">
              <FontAwesomeIcon
                icon={faInstagram}
                className="h-8 w-8 cursor-pointer text-pink-500"
                onClick={shareOnInstagram}
              />
              <span className="text-sm mt-1 text-white m-2">Instagram</span>
            </div>
          </div>
        </BaseModal>
      )
}